import React, { Component } from 'react';
import FooterOne from './footer';
import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';

class MainFooter extends Component{
    render(){
        const { presentURL, isAuth } = this.props;
        return(
            <React.Fragment>
                 {
                        !isAuth ?
                            ''
                        :
                            // <FooterOne />
                            ''
                     
                 }
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state, ownProps) => ({
    isAuth: state.user.isAuth,
    connection_id: state.tenant.connection_id,
    presentURL: state.tenant.presentURL,
});

// export default MainHome;
export default connect(
    mapStateToProps,
    // mapDispatchToProps
)(withRouter(MainFooter));